import Store from '@/store';
import SLSParametros from '@/api/SistemaDKP/sls-parametros.client';
import { ErrorMessage } from '@/libs/Error';

export default class SLSItemService {
  constructor() {
    this.client = new SLSParametros();
    this.error = new ErrorMessage();
    this.store = Store;
  }

  async findAll(queries = { fullObject: false }) {
    try {
      const { data } = await this.client.findAll(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os items');
    }
  }

  async create(data) {
    try {
      return await this.client.create(data);
    } catch (error) {
      this.error.message(error, 'Erro ao listar os items');
    }
  }

  async findByDescricao(descricao) {
    try {
      return await this.client.findByDescricao(descricao);
    } catch (error) {
      this.error.message(error, 'Erro ao listar os items');
    }
  }
}
